export default class RqHoteles {
  constructor(form) {
    this.form = form
  }
  procesar() {
    const habitaciones = this.procesarHabitacion()
    this.rq = this.toBusqueda(
      this.form.destino,
      this.form.checkin,
      this.form.checkout,
      this.form.categoria,
      habitaciones,
      this.form.isDc
    )
  }
  procesarHabitacion() {
    let habitaciones = []
    this.form.ocupacion.map(o => {
      let edades = []
      o.edades.map(e => {
        edades.push(e.edad)
      })
      habitaciones.push({ adl: o.adultos, menores: { edades: edades } })
    })
    return habitaciones
  }
  toBusqueda(destino, fin, fout, categoria, habitaciones, isDc) {
    return {
      destino: destino,
      categoria: categoria,
      habitaciones: habitaciones,
      checkin: fin,
      checkout: fout,
      isDc: isDc
    }
  }
  getRq() {
    return this.rq
  }
  completarBusqueda() {
    // Arma la data para pasarle al compoente de busqueda "buscando"
    return {
      method: "POST",
      url: process.env.VUE_APP_ASBACK + "/api/get-disponibilidad",
      data: this.rq
    }
  }
  armarParametros2Espera(toError, mensajeError, toAfter, toSinDispo = null) {
    this.procesar()
    let methodData = this.completarBusqueda()
    let redirect = { to: toError, mensaje: mensajeError }
    let data2To = {
      busqueda: methodData.data,
      toSinDispo: toSinDispo === null ? toError : toSinDispo
    }
    return {
      to: toAfter,
      redirect: redirect,
      methodData: methodData,
      data2To: data2To,
      mensaje: "Buscando hoteles"
    }
  }
  armarParametros2EsperaTicket(toError, mensajeError, toAfter, toSinDispo = null) {
    this.procesarTicket()
    let methodData = this.completarBusquedaTicket()
    let redirect = { to: toError, mensaje: mensajeError }
    let data2To = {
      busqueda: methodData.data,
      toSinDispo: toSinDispo === null ? toError : toSinDispo
    }
    return {
      to: toAfter,
      redirect: redirect,
      methodData: methodData,
      data2To: data2To,
      mensaje: "Buscando Tickets"
    }
  }
  procesarTicket() {
    this.rq = this.toBusquedaTicket(
      this.form.destino,
      this.form.breve,
      this.form.checkin,
      this.form.checkout,
      this.form.adl,
      this.form.chd,
      0,
      this.form.codigo,
      this.form.dias,
      0
    )
  }
  completarBusquedaTicket() {
    // Arma la data para pasarle al compoente de busqueda "buscando" a pases
    return {
      method: "POST",
      url: process.env.VUE_APP_ASBACK + "/api/get-pases",
      data: this.rq
    }
  }
  toBusquedaTicket(destino, breve, checkin, checkout, adl, chd, jr, codigo, dias, todo) {
    return {
      destino: destino,
      breve: breve,
      checkin: checkin,
      checkout: checkout,
      adl: adl,
      chd: chd,
      jr: jr,
      codigo: codigo,
      dias: dias,
      todo: todo
    }
  }
  armar2EsperaTarifario(toError, mensajeError, toAfter, toSinDispo = null) {
    const armado = this.armar(`${process.env.VUE_APP_ASBACK}/api/get-tarifario`, "POST", this.form)
    let redirect = { to: toError, mensaje: mensajeError }
    let data2To = {
      busqueda: armado.data,
      toSinDispo: toSinDispo === null ? toError : toSinDispo
    }
    return {
      to: toAfter,
      redirect: redirect,
      methodData: armado,
      data2To: data2To,
      mensaje: "Buscando Tarifarios"
    }
  }
  armar(url, method, rq) {
    return { method: method, url: url, data: rq }
  }
}
